/**
 * PolicySlice Extra Reducers
 * 
 * Handles async actions from RTK Query endpoints.
 */

import { ActionReducerMapBuilder } from '@reduxjs/toolkit';
import { PolicySliceState } from './state';
import { policyEndpoints } from '../endpoints/policyEndpoints';

/**
 * Builds extra reducers for policy API endpoint matchers.
 */
export function buildPolicyExtraReducers(builder: ActionReducerMapBuilder<PolicySliceState>) {
  builder.addMatcher(
    policyEndpoints.endpoints.getPolicy.matchFulfilled,
    (state, action) => {
      state.currentPolicy = action.payload;
      state.isEdited = false;
      state.editedFields = [];
      state.validationErrors = {};
    }
  );
}
